export enum LayoutType {
  DEFAULT = 'DEFAULT',
  CONSOLE = 'CONSOLE',
  NAKED = 'NAKED'
}
